import { Exclude, Type } from 'class-transformer';
import { FindAllQueryDto } from './find-all-query.dto';

export class FindAllQueryResponseDto<Entity extends object = object> extends FindAllQueryDto<Entity> {
	@Exclude()
	private objectType: Function;

	@Type((options) => (options?.newObject as FindAllQueryResponseDto<Entity>).objectType)
	data: Entity[];

	total: number;

	constructor(objectType: Function) {
		super();
		this.objectType = objectType;
	}
}
